var map = {
	"./translations-en.config.yml": 903,
	"./translations-he.config.yml": 904
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 902;



/*****************
 ** WEBPACK FOOTER
 ** ./client/app/shared/translator ^\.\/translations\-.*\.config\.yml$
 ** module id = 902
 ** module chunks = 0
 **/